<script setup lang="ts">

const props = withDefaults(defineProps<{
    typeView: string;
    modelValue: boolean;
    changeGrid?: boolean;
    selectedDirection?: ApiDirection;
    searchValue?: string;
    viewChangeGrid?: boolean;
}>(), {
    viewChangeGrid: true
});

const emit = defineEmits<{
    (e: 'update:modelValue', payload: boolean): void;
    (e: 'update:changeGrid', payload: boolean): void;
    (e: 'onChangeDirection', payload: ApiDirection): void;
    (e: 'onChangeSearch', payload: string): void;
}>();

const directionValues: OptionValue<ApiDirection>[] = [
    {
        label: 'Price low to high',
        value: 'asc'
    },
    {
        label: 'Price high to low',
        value: 'desc'
    }
];

</script>

<template>
  <div class="width-full display-flex align-items-center gap-8">
    <button class="compact-500-accent sorts-btns display-flex align-items-center justify-center gap-8 filter cursor-pointer"
            type="button"
            @click.stop="emit('update:modelValue', !modelValue)"
    >
      <IconMain :size="24"
                icon="to-left"
                :class="[ 'display-none-bp-768', { 'rotate-icon': !modelValue }]"
      />

      <span class="display-none-bp-768 compact-500-accent">
        Filter
      </span>

      <IconMain :size="20"
                icon="filter"
                class="mobile-sort-btn"
      />
    </button>
    <SearchInput :initial-value="searchValue"
                 aria-label="collection search"
                 class="width-full"
                 @on-change-debounce="(val: string) => emit('onChangeSearch', val)"
    />
    <SortDropdown v-if="props.typeView === 'collection' && selectedDirection"
                  :values="directionValues"
                  label="Sort"
                  :selected-value="selectedDirection"
                  @on-change="(val:ApiDirection) => emit('onChangeDirection', val)"
    />

    <div v-if="viewChangeGrid"
         class="display-flex align-items-center bg-segment display-none-bp-1200">
      <button type="button"
              class="segment-btn cursor-pointer"
              :class="{ 'active-bg': !props.changeGrid }"
              aria-label="default grid"
              @click="emit('update:changeGrid', false)"
      >
        <IconMain :size="24"
                  icon="grid"
        />
      </button>
      <button type="button"
              aria-label="small grid"
              class="segment-btn cursor-pointer"
              :class="{ 'active-bg': props.changeGrid }"
              @click="emit('update:changeGrid', true)"
      >
        <IconMain :size="24"
                  icon="grid-small"
        />
      </button>
    </div>
  </div>
</template>

<style lang="scss">
.sorts-btns {
  min-width: var(--control-500-size-single, 52px);
  height: var(--control-500-size-single, 52px);
  padding: 0 10px;
  border-radius: var(--control-500-radius, 2px);
  background: var(--bg-secondary);
  color: var(--content-primary);
}

.filter {
  width: 100%;
  max-width: 112px;
  transition: opacity 0.4s ease;

  @include tablet-768 {
    width: initial;
  }

  &:hover {
    opacity: 0.4;
  }

  svg {
    width: 24px;
    height: 24px;
    transition: transform 0.3s ease;
  }
}

.filter-by {
  width: 100%;
  max-width: 238px;

  @include mobile-576 {
    width: initial;
  }
}

.bg-segment {
  padding: 4px;
  border-radius: var(--background-500-radius, 4px);
  background: var(--bg-secondary);
}

.segment-btn {
  width: 44px;
  height: 44px;
  border: none;
  background: transparent;
  color: var(--content-primary);
}

.rotate-icon {
  transform: rotate(180deg);
}

.active-bg {
  background: var(--bg-tertary);
}

.mobile-sort-btn {
  display: none;

  @include tablet-768 {
    display: inline;
  }
}
</style>
